define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var wraper = $('.kundenbewertungen_body');
        var finder = $('.kundenbewertungen_body .kundenbewertung');
        var buttons = $('.kundenbewertungen_headerSortOption');
        var template = $($('.kundenbewertungen_body .kundenbewertung:first').prop('outerHTML')) || $();
        var sort = 'createdAt,desc';
        var page = 0;
        var num = '20';
        var wrap = $('.kundenbewertungen_body') || $();
        $('.load_more_reviews').css('display', 'block');
        buttons.attr('data-direction', 'asc');
        buttons.on('click', function () {
            page = 0;
            num = '20';
            if ($(this).attr('data-order-by') == 'rating') {
                if ($(this).attr('data-direction') == 'asc') {
                    sort = 'rating,asc',
                        $(this).attr('data-direction', 'desc');
                }
                else {
                    sort = 'rating,createdAt,desc',
                        $(this).attr('data-direction', 'asc');
                }
            }
            if ($(this).attr('data-order-by') == 'createdAt') {
                if ($(this).attr('data-direction') == 'asc') {
                    sort = 'createdAt,asc',
                        $(this).attr('data-direction', 'desc');
                }
                else {
                    sort = 'createdAt,desc',
                        $(this).attr('data-direction', 'asc');
                }
            }
            wrap.empty();
            ajaxcall();
        });
        $('.load_more_reviews').on('click', function () {
            if (page == 0) {
                page = 1;
            }
            if (sort == 'rating,asc' || sort == 'createdAt,asc') {
                page = 2;
            }
            page++;
            num = '10';
            ajaxcall();
        });
        function ajaxcall() {
            $('.load_more_reviews').before('<div class="loading_circle"></div>');
            $.ajax({
                url: 'https://drklein.drklein-plattform.de/api/c-agentservice/v2/bvo-reviews?page=' + page + '&size=' + num + '&sort=' + sort,
                cache: false,
                type: 'GET',
                dataType: 'json',
                success: function (ret) {
                    var ob = $();
                    console.log(ret);
                    var reviews = ret._embedded.reviews;
                    if (sort == 'rating,asc' || sort == 'createdAt,asc') {
                        reviews = reviews.reverse();
                    }
                    $.each(ret._embedded.reviews, function (i, data) {
                        ob = template.clone();
                        ob.find('.kundenbewertung_kunde').text(data.authorFirstNameInitial + '. ' + data.authorLastNameInitial + '. aus ' + data.authorPlaceOfResidence);
                        ob.find('.zitat').text(data.reviewText);
                        ob.find('.zitat_text').text(data.reviewText);
                        ob.find('.starsRating_stars--is-foreground').attr('style', 'width: calc(' + data.rating + '*20%)');
                        ob.find('.kundenbewertungNote_noteState').text(data.rating);
                        var ts = new Date(data.createdAt);
                        var day = String(ts.getUTCDate()).padStart(2, '0');
                        var month = String(ts.getUTCMonth() + 1).padStart(2, '0');
                        var createdAt = [day, month, ts.getFullYear()].join(".");
                        ob.find('.kundenbewertung_datum').text('Datum: ' + createdAt);
                        wrap.append(ob);
                    });
                    $('.loading_circle').remove();
                }
            });
        }
    });
});
